import ImportInstructions from './ImportInstructions';
import Title from './Title';

const ImportEntries = { Title, ImportInstructions };

export default ImportEntries;
